
import { requests } from '.'
import { Filter } from '../commons/Types';
import AddOn, { AddOnInfo } from '../models/AddOn.model';
import ListData from '../models/List.model';
import Video from '../models/Video.model';

export const AddOnApi = {
  getAddOnList: () => requests.get<AddOnInfo>('v1/add-on'),
};